<style lang="stylus" scoped>
@import '../css/var'
  .page
    padding-top 30px
    background #F2F3F4
    min-height 100vh

</style>
<template>
  <div class="page">
      <v-no-data  v-if='showNOData'/>
    <v-cells v-if='calculatedData.length > 0'  paddingBottom="20pt" paddingTop="3pt" paddingLeft="16pt"  paddingRight="16pt">
      <v-item-cell leftText="时间" middleText="充值金额" rightText="消费金额" middleColor='#30C37E' rightColor='red'/>
      <v-item-cell :key="index" v-for="(item, index) in calculatedData" @click="detail(item)" :leftText="item.date" :middleText="formatPriceNumber(item.recharges.reduce((acc, cur) => acc += cur.rechargeAmount, 0))" :rightText="formatPriceNumber(item.consumes.reduce((acc, cur) => acc += cur.totalPrice, 0))" middleColor='#30C37E' rightColor='red' :rightArraw='true'/>
    </v-cells>
</div>
</template>
<script>
import mixin from './mixin'
import { mapState, mapActions } from 'vuex'
import moment from 'moment'
import { GET_CONSUME_ORDERS, GET_RECHARGE_ORDERS, SET_MONTHLY_REFRESH_LOCK, REFRESH_MONTHLY_ORDERS } from '../store/records'
export default {
  mixins: [mixin],
  data () {
    return {
      monthTime: '',
      showNOData: false
    }
  },
  created () {
    this.setTitle('月账单')
    this.SET_MONTHLY_REFRESH_LOCK(true)
    this.REFRESH_MONTHLY_ORDERS(this.param())
  },
  computed: {
    ...mapState({
      user: state => state.user,
      consumeOrders: state => state.records.consumeOrders,
      rechargeOrders: state => state.records.rechargeOrders,
      calculatedData: state => state.records.monthDivideOrders})
  },
  mounted () {
    this.setTitle('月账单')
    moment().local()
  },
  methods: {
    ...mapActions([GET_CONSUME_ORDERS, GET_RECHARGE_ORDERS, SET_MONTHLY_REFRESH_LOCK, REFRESH_MONTHLY_ORDERS]),
    detail (item) {
      if (item.consumes.length === 0 && item.recharges.length === 0) {
        this.showToast('该月无支出记录')
        return
      }
      // sessionStorage.setItem('a-month-bill', JSON.stringify(item))
      $router.push({
        path: '/a-month-bill',
        query: {beginDate: item.begin}
      })
    },
    getTimeRange (index) {
      // return this.getMonthlyRange((1 - 3 * index), -(3 * (index - 1)))
      return this.getMonthlyRange((-6 * index), -(6 * (index - 1)))
    },
    param () {
      let {start, end} = this.getTimeRange(1)
      return {user: this.user, start: start, end: end, page: 1}
    }
  }
}
</script>



// WEBPACK FOOTER //
// month-bill.vue?31982dd1